'use client';

import { useState } from 'react';

import { Modal, Spacer, SpacerSize, Title, TypographyAlign, View } from '@bytel/trilogy-react-ts';

import { SSIBlock } from '@components/ssi-block';

import { Faq } from '../../faq';
import FinePrint from './fine-print';
import HomeBreadcrumb from './home-breadcrumb';

type PageBottomContentProps = {
    mobilePlanFirst: boolean;
};
export default function PageBottomContent({ mobilePlanFirst }: Readonly<PageBottomContentProps>) {
    const [shouldShowMentionsModal, setShouldShowMentionsModal] = useState(false);

    return (
        <>
            <View className='mwdapp ac'>
                <Faq isMobilePlan={mobilePlanFirst} />

                <View className='has-text-centered mt-2'>
                    <button
                        className='link button-clear has-text-tertiary eventTextColor'
                        title='Infos légales'
                        aria-label='Mentions légales'
                        onClick={() => setShouldShowMentionsModal(true)}
                    >
                        Mentions légales
                    </button>
                </View>

                <FinePrint />
                <Spacer size={SpacerSize.LARGE} />
                <HomeBreadcrumb />
            </View>

            <Modal active={shouldShowMentionsModal} onClose={() => setShouldShowMentionsModal(false)} closeIcon>
                <Title typo={TypographyAlign.TEXT_LEFT}>Mentions légales</Title>
                <div className='has-text-left'>
                    <SSIBlock
                        url='/partials/mentions_legales/emplacements/forfaits-mobiles_sans-engagement'
                        tagId='mentions-legales'
                    />
                </div>
            </Modal>
        </>
    );
}
